const Vue = require('vue')
const bus = require('sci/std/bus')
const { Node } = window
const debounceAcc = require('microsistec/debounce-acc')
const {
    fieldPathMatcher
} = require('sci/helpers')

const focus = debounceAcc((entries) => {
    const ordered = entries.sort((ea, eb) => {
        const a = ea.component.$el
        const b = eb.component.$el

        if (a === b) {
            return 0
        }

        const position = a.compareDocumentPosition(b)

        if (position & Node.DOCUMENT_POSITION_FOLLOWING ||
            position & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return -1
        } else if (position & Node.DOCUMENT_POSITION_PRECEDING ||
            position & Node.DOCUMENT_POSITION_CONTAINS) {
            return 1
        } else {
            return 0
        }
    })

    const entry = ordered[0]

    if (entry) {
        entry.component.onError && entry.component.onError(entry.errors)
    }
}, 50)

Vue.component('form-errors', {
    props: {
        fields: {
            type: Array,
            required: true
        },
        onError: {
            type: Function,
            default: null
        },
        head: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        globs () {
            return this.fields.map(f => fieldPathMatcher(this.$contextPath(
                [f])))
        },
        boot () {
            bus.$on('errors', this.receivedErrors)
        },
        die (form = null) {
            bus.$off(`errors`, this.receivedErrors)
        },
        receivedErrors ({
            formName,
            errors
        }) {
            const ctx = this.$context()

            if (!ctx) {
                return
            }

            if (!ctx.path.startsWith(formName + '^') && ctx.path !== formName) {
                return
            }

            try {
                const globs = this.globs()

                const newErrors = errors.filter(([key, value]) => {
                    return globs.some(_ => _.some(key))
                }).reduce((a, [_, e]) => a.concat(e), [])

                if (this.head) {
                    this.errors = newErrors.slice(0, 1)
                } else {
                    this.errors = newErrors
                }
            } catch (err) {
                console.error(this.$context(), this.$parents(), err)
            }

            if (this.errors.length > 0 && this.onError !== null) {
                focus({ component: this, errors: this.errors })
            }
        }
    },
    init () {},
    destroyed () {
        this.die()
    },
    data () {
        return {
            watching: null,
            form: null,
            errors: []
        }
    },
    ready () {
        this.boot()
    },
    watch: {
        form (newVal, oldVal) {
            this.die(oldVal)
            this.boot()
        },
        fields (newVal) {}
    },
    template: `
        <div>
            <div v-if="errors.length > 0" class="text-danger">
                <div v-for="error in errors">{{ error.message }}</div>
            </div>
        </div>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/errors.js